import { IAppState } from '../common/state';

export const getIsNewbuildingPromoCarouselEnabled = (state: IAppState) =>
  state.featureToggle.isNewbuildingPromoCarouselEnabled;
